import React from 'react';
import PropTypes from 'prop-types';
import { Link, browserHistory } from 'react-router';

const BackButton = (props) => {
  if (!props.to) {
    return (
      <a className="btn" style={props.style} onClick={browserHistory.goBack}>
        <i className="bi_interface-left" />
        Indietro
      </a>
    );
  }
  return (
    <Link to={props.to} style={props.style}>
      <i className="bi_interface-left" />
      Indietro
    </Link>
  );
};

BackButton.propTypes = {
  to: PropTypes.string,
  style: PropTypes.object,
};

export default BackButton;



// WEBPACK FOOTER //
// ./src/components/back-button.js